import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { CustomTagManager } from '../../utils/GTM';
import PageContainer from '../../components/PageContainer';
import AppBanner from '../../components/AppBanner';
import FlipClock from '../../components/FlipClock';
import useQueryString from '../../hooks/useQueryString';
import logo from './assets/logo.png';
import {
  defaultColor,
  FixedLogoWrap,
  TimeOverPageWrap,
} from './styles/default.style';

const TimeOverPage = () => {
  const { countryCode } = useQueryString();
  const { t } = useTranslation();

  // UZ(우즈베키스탄), PH(필리핀)의 경우 앱 배너 및 팝업 표시하지 않음
  const hideAppBanner = countryCode === 'UZ' || countryCode === 'PH';

  useEffect(() => {
    CustomTagManager.QR_Download_Page_View_Expired();
  }, []);

  return (
    <PageContainer $backgroundColor={defaultColor.main}>
      <TimeOverPageWrap>
        {hideAppBanner ? (
          <FixedLogoWrap>
            <img src={logo} alt="PHOTOGRAY" />
          </FixedLogoWrap>
        ) : (
          <AppBanner $isFixedTop />
        )}
        <h2>{t('THANK_YOU')}</h2>
        <FlipClock
          $clockColor={defaultColor.clock}
          $dotColor={defaultColor.clock}
          timeOver
          style={{ margin: '24px 0' }}
        />
        <p>{t('TIME_OVER')}</p>
      </TimeOverPageWrap>
    </PageContainer>
  );
};

export default TimeOverPage;
